import { DotLottiePlayer } from '@dotlottie/react-player';
import { Typography } from 'antd';
import { formatToINR, getNudgeDescription, getNudgeBodyText } from '../../../Utils/utils';
import Transaction from '../../Dashboard/Common/Transaction';
import HeaderSubHeader from '../Header/HeaderSubHeader';
import styles from './index.module.css';
import { getLottiePath } from '../../../Utils/assetUtils';
import { PoweredByIgnosis } from '../common/PoweredByIgnosis';

const NudgeDetails: React.FC<{
  selectedNudge: any;
  selectedNudgeTransaction: any;
}> = ({ selectedNudge, selectedNudgeTransaction }) => {
  const nudgeBodyText = getNudgeBodyText(selectedNudge);

  return (
    <div className={styles.moreInsightsRoot}>
      <HeaderSubHeader
        header={
          nudgeBodyText
            ? nudgeBodyText
            : getNudgeDescription(selectedNudge).replace(
                /₹XXX/g,
                formatToINR(
                  selectedNudge.parameter.filter(
                    (para: any) => para.name === 'amount'
                  ).length > 0 &&
                    selectedNudge.parameter.filter(
                      (para: any) => para.name === 'amount'
                    )[0].value
                    ? selectedNudge.parameter
                        .filter((para: any) => para.name === 'amount')[0]
                        .value.toString()
                    : '0'
                )
              )
        }
      />

      <>
        <Typography.Text
          style={{
            color: 'rgb(69, 72, 77)',
            // font-size: 10px;
            // font-weight: 600;
            // margin-top: 16px;
            marginTop: 24,
            fontSize: 10,
            fontWeight: 600,
          }}
        >
          TRANSACTIONS
        </Typography.Text>
        {selectedNudgeTransaction.length > 0 ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {selectedNudgeTransaction.map((transaction: any) => {
              return (
                <>
                  <Transaction
                    showTransactionDetails={true}
                    transaction={transaction}
                    showDateOfTransaction={true}
                  />
                </>
              );
            })}
          </div>
        ) : (
          <DotLottiePlayer
            speed={2}
            id='loadingLottie'
            src={getLottiePath('loading.lottie')}
            autoplay
            loop
            style={{
              height: '80px',
            }}
          />
        )}
      </>
      <PoweredByIgnosis />
    </div>
  );
};

export default NudgeDetails;
